import styled from 'styled-components';
import {
  py, m, p, mt, mb
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';
import { colors } from '@components/ListItemFacility/styles';
import { RichTextStyle } from '@lib/styles/richtextEditiorStyles';

export const StyledDetailsCover = styled.div`
  ${py(3)};
  ${m(2)};
`;

export const StyledSepratorGray = styled.hr`
  color: ${theme.colors.gray};
  width: 100%;
  &:nth-last-child(1) {
    display: none;
  }
`;

export const StyledMainHeadline = styled.div`
  font-size: 26px;
  font-weight: bold;
  line-height: 1.5rem;
  ${p(3)};
  ${breakpoint('mobile', 'desktop')`
    font-size: 22px;
  `}
`;

export const StyledTitle = styled.div`
  color: #3a3a3a;
  line-height: 1.5rem;
  font-weight: 600;
  font-size: 22px;
  ${breakpoint('mobile', 'desktop')`
    font-size: 18px;
  `}
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 6px;
  cursor: pointer;
  ${p(3)};
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  ${m(1)};

  svg,
  path {
    width: 18px;
    height: 18px;
    transform-origin: center;
    fill: #3a3a3a;
    transform: ${props => (props.active ? 'rotate(90deg)' : '')};
    transition: all 500ms ease-in-out 0s;
    ${breakpoint('mobile', 'tablet')`
    width: 16px;
    height: 16px;
  }  `};
  }
`;

export const StyledDescription = styled.div`
  position: relative;
  color: #3a3a3a;
  font-size: 18px;
  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
  `}
  line-height: 1.5rem;
  ${p(3)};
  letter-spacing: 0.5px;
  width: calc(100% - 40px);
  max-height: 0px;
  padding: 0px 20px;
  overflow: hidden;
  transition: all 0.3s;
  ${({ active }) =>
    active
    && `
    padding: 20px;
    max-height: 1000px;
    overflow: hidden;
    transition: all 0.3s;
  `};
  ${RichTextStyle}
`;

export const StyledCardWrapper = styled.div`
  border-radius: 8px;
  ${mt(3)}
  ${mb(3)}
  border: 2px solid transparent;
  box-shadow: 0 3px 5px 0 #cccccc;
  background-color: ${colors.VeryLightBlue};
`;
